import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"

import Nav from 'react-bootstrap/Nav'
import SidebarToggle from './sidebarToggle'

import logo from '../images/logo.png'

const Header = (props) => {
    const data = useStaticQuery(
        graphql
        `query {
            allMainNavigationJson {
                edges {
                  node {
                    mainNavigation {
                      label
                      name
                      path
                    }
                  }
                }
            }
        }`
    )

    let menuData = data.allMainNavigationJson.edges[0].node.mainNavigation

    const navItems = menuData.map((entry) =>
        <Nav.Item as="li">
            <Link className="nav-link" activeClassName="nav-item-active" to={entry.path} href={entry.path}>{entry.label}</Link>
        </Nav.Item>
    );

    return (
        <header className="header">
            <div className="brand">
                <a href="/">
                    <img src={logo} alt="brandLogo"/>
                </a>
            </div>
            <div className="brandHeader">
                <div className="brandMain"><a href="/"><span className="zeroColor">Ines</span> <span className="primaryColor">Püttcher</span></a></div>
            </div>
            <div className="navHeader">
                <div className="brandMain"><a href="/"><span className="zeroColor">Ines</span> <span className="primaryColor">Püttcher</span></a></div>
                <SidebarToggle click={props.clickFunction} buttonState={props.menuState} />
                <Nav as="ul" className="primaryNav justify-content-end" activeKey="/home">
                    {navItems}
                </Nav>
            </div>
            <div className="subHeader">
                <a href="/">
                    <div className="brandItem">Hauskrankenpflege</div>
                </a>
            </div>
        </header>
    )
}

export default Header

